export default "__VITE_ASSET__7881b8f8__"